<script setup>
import {defineProps} from "vue";
import CommentArea from "@/views/projects/pdf/comments/CommentArea.vue";
import DroppedItem from "@/views/projects/pdf/contents/DroppedItem.vue";

const props = defineProps({
  currentLayout: Object,
  sourceType: String,
  selectedBlocks: Array,
  findElements: Function,
  clearSelectedBlocks: Function
})


const unitToPx = (unit, addPX = true) => {
  return `${(unit / 12700) * 1.333}${addPX ? 'px' : ''}`
}

const groupedArray = (data) => {
  const grouped = data.reduce((acc, curr) => {
    const key = curr[1]
    if (!acc[key]) {
      acc[key] = []
    }
    const accumulative = {
      ...{coord: [curr]},
      ...defaultData
    }
    acc[key].push(accumulative)
    return acc
  }, {})
  return Object.values(grouped)
}

const defaultSourceStyle = {
  wc: {
    fontSize: 10,
    bold: false,
    color: "#ffffff",
    replace: true
  },
  ln: {
    fontSize: 10,
    bold: false,
    color: "#000000",
    replace: false
  },
  dj: {
    fontSize: 10,
    bold: false,
    color: "#000000",
    replace: false
  },
}

const defaultData = {
  colspan: 1,
  rowspan: 1,
  style: defaultSourceStyle[props.sourceType]
}


const drop = ({position}) => {
  if (props.selectedBlocks.length) {
    const defaultCell = {
      ...{coord: []},
      ...defaultData
    }
    if (props.selectedBlocks.length === 1 && position) {
      props.currentLayout.droppedItems[position[0]][position[1]].coord.push(props.selectedBlocks[0])
    } else {

      let blocks = groupedArray(props.selectedBlocks)
      blocks.forEach(block => {
        block.forEach(b => {
          let element = props.findElements(b.coord)
          if (element && element[0] && element[0].style) {
            let color = element[0].style.color;
            console.log(b)
            if (defaultData.style.replace) color = defaultData.style.color

            b.style = {
              ...b.style,
              color: color,
              fontSize: element[0].style["font-size"]
            }

          }
        })
      })

      props.currentLayout.droppedItems = props.currentLayout.droppedItems.concat(blocks)
    }
    const max = Math.max(...props.currentLayout.droppedItems.map(x => x.length))
    props.currentLayout.droppedItems.forEach((x, i) => {
      props.currentLayout.droppedItems[i] = x.concat([...Array(max - x.length).keys()].map(i => JSON.parse(JSON.stringify(defaultCell))))
    })
    // props.selectedBlocks = []
    props.clearSelectedBlocks()
  }
}
const handleItemDrop = ({sourceCoords, sourceParams, targetParams}) => {
  const newItems = [...props.currentLayout.droppedItems]
  const source = newItems[sourceParams[0]][sourceParams[1]]
  const target = newItems[targetParams[0]][targetParams[1]]
  target.coord.push(sourceCoords)
  source.coord = source.coord.filter(item => JSON.stringify(item) !== JSON.stringify(sourceCoords));

  props.currentLayout.droppedItems = [...props.currentLayout.droppedItems]
}

const deleteRow = ({coord}) => {
  props.currentLayout.droppedItems = props.currentLayout.droppedItems.filter((e, i) => i !== coord[0])
}
const deleteCol = ({coord}) => {
  props.currentLayout.droppedItems = props.currentLayout.droppedItems.filter((e, i) => i !== coord[1])
}

const addRow = ({coord}) => {
  props.currentLayout.droppedItems = props.currentLayout.droppedItems.filter((e, i) => i !== coord[0])
}
const addCol = ({coord}) => {
  props.currentLayout.droppedItems = props.currentLayout.droppedItems.filter((e, i) => i !== coord[0])
}
const mergeCol = ({coord}) => {
  const lines = [...props.currentLayout.droppedItems]
  if (lines[coord[0]][coord[1] + 1]) {
    lines[coord[0]][coord[1]].colspan += 1
    lines[coord[0]][coord[1]].coord = [...lines[coord[0]][coord[1]].coord, ...lines[coord[0]][coord[1] + 1].coord]
    lines[coord[0]].splice(coord[1] + 1, 1);
  }
  props.currentLayout.droppedItems = lines
}
const mergeRow = ({coord}) => {
  const lines = [...props.currentLayout.droppedItems]
  const currentSpan = lines[coord[0]][coord[1]].rowspan
  if (lines[coord[0] + currentSpan][coord[1]]) {

    lines[coord[0]][coord[1]].rowspan += 1
    lines[coord[0]][coord[1]].coord = [...lines[coord[0]][coord[1]].coord, ...lines[coord[0] + currentSpan][coord[1]].coord]
    lines[coord[0] + currentSpan].splice(coord[1], 1);
  }
  props.currentLayout.droppedItems = lines
}
const splitCell = ({coord}) => {
  const lines = props.currentLayout.droppedItems
  const currentCell = lines[coord[0]][coord[1]]
  const defaultCell = {
    ...{coord: []},
    ...defaultData
  }
  // if (currentCell.rowspan) {

    // for [i in currentCell.rowspan]
  // }
  if (currentCell.colspan) {
    const firstLine = lines[coord[0]]
    // const secondLine = [...lines[coord[0]].slice(coord[1]+1)]

    for (let i = 0; i < currentCell.colspan; i++) {
      lines[coord[0]].concat([JSON.parse(JSON.stringify(defaultCell))])
    }
    props.currentLayout.droppedItems = [...lines]


  }
}


</script>

<template>
  <div>
    <h4>{{ currentLayout?.name }}</h4>
    <div :class="`layout ${sourceType}`" id="layout"
         :style="{width: unitToPx(currentLayout?.slide_width), height: unitToPx(currentLayout?.slide_height)}">
      <template v-if="currentLayout">
        <template v-for="place in currentLayout.placeholders">
          <div :class="'placeholder drop-zone'+(place.name === 'основной текст'?' area':'')"
               @dragover.prevent
               @drop="drop"
               :style="{width: unitToPx(place.width), height: unitToPx(place.height), top: unitToPx(place.top), left: unitToPx(place.left)}">
            <span class="badge">{{ place.name }}</span>

            <table v-if="place.name === 'основной текст'" class="dropped-table table">
              <tbody>
              <tr v-for="(row, rowIndex) in currentLayout.droppedItems" :key="rowIndex">
                <template v-for="(col, colIndex) in row" :key="`${rowIndex}-${colIndex}`">
                  <DroppedItem
                      :elements="findElements(col.coord)"
                      :parameters="col"
                      :coord="[rowIndex, colIndex]"
                      @drop="drop"
                      @item-dropped="handleItemDrop"
                      @delete-row="deleteRow"
                      @delete-col="deleteCol"
                      @add-col="addCol"
                      @add-row="addRow"
                      @merge-col="mergeCol"
                      @merge-row="mergeRow"
                      @split-cell="splitCell"
                  ></DroppedItem>

                </template>
              </tr>
              </tbody>
            </table>

            <comment-area v-if="place.name === 'комментарии'" :comments="currentLayout.comments"></comment-area>
          </div>
        </template>
        <template v-for="place in currentLayout.icons">
          <div class="icons" :title="place.name"
               :style="{width: unitToPx(place.width), height: unitToPx(place.height), top: unitToPx(place.top), left: unitToPx(place.left)}">
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout {
  display: block;
  border: 1px solid #999;
  position: relative;

  &.wc {
    .area {
      background: #000 !important;
    }
  }

  .placeholder {
    z-index: 2;
    border: 1px solid #999;
    position: absolute;
    display: block;
    background: repeating-linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1) 10px,
            transparent 10px,
            transparent 20px
    );

    &.area {
      background: #fff;
    }

    .badge {
      background: #ccc;
      border-radius: 5px;
      color: #000000;
      font-size: 9px;
      padding: 0;
      line-height: 10px;
      top: -9px;
      position: absolute;
    }

    table {
      background: transparent;
      width: 100%;
      table-layout: fixed;

      td {
        border: 1px solid #ccc;
      }
    }
  }

  .icons {
    z-index: 1;
    border: 1px solid #000;
    position: absolute;
    display: block;
    background: repeating-linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1) 10px,
            transparent 10px,
            transparent 20px
    );
  }
}
</style>